<template>
  <div class="home">
    <!-- 无 -->
    <div v-if="none" class="none">
      <div class="none_tip">暂无公开课课程哦~快去学习中心学习吧</div>
      <div class="goStudy">去学习</div>
    </div>
    <!-- 有 -->
    <div v-else>
      <img class="bannerImg" src="../../assets/img/home/bg-1.png" alt="" />
      <div class="content_box">
        <div class="live_box">
          <img class="classImg" src="../../assets/img/home/bg-1.png" alt="" />
          <div class="live_right">
            <div class="live_tit">大学语文答疑课</div>
            <div class="live_info">
              <div>上课时间：2020-10-20 16:52</div>
              <div>授课老师：郑东风</div>
              <div>郑州信息工程职业技术学院 教育系主任</div>
            </div>
            <div class="live_desc">
              解决高等数学难题，讲解一学期积累问题，有需要的同学请按时参加解决高等数学难题，讲解一学期积累问题，有需要的同学请按时参加解决高等数学难题，讲解一学期积累问题，有需要的同学请按时参加解决高等数学难题，讲解一学期积累问题，有需要的同学请按时参加
            </div>
            <!-- 倒计时 -->
            <div class="count_dowm" v-cloak>
              距离开课还有
              {{ time.d + ":" + time.h + ":" + time.m + ":" + time.s }}
            </div>
            <div class="start_btn">开始上课</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      timeOver: false, // 倒计时结束标识
      endTime: "2020-9-30 18:00", // 结束时间
      time: {},
      none: false,
    };
  },
  created() {
    let that = this;
    that.timeDown();
  },
  methods: {
    timeDown() {
      var that = this;
      if (new Date(that.endTime) - new Date() < 0) {
        return;
      }
      var interval = setInterval(function trans() {
        var date = new Date(that.endTime) - new Date();
        if (date <= 0) {
          that.timeOver = true;
          clearInterval(interval);
        } else {
          that.$set(that.time, "d", parseInt(date / 1000 / 60 / 60 / 24, 10));
          that.$set(that.time, "h", parseInt((date / 1000 / 60 / 60) % 24, 10));
          if (that.time.h < 10) {
            that.$set(that.time, "h", "0" + that.time.h);
            // that.$set(that.time.h);
          }
          that.time.m = parseInt((date / 1000 / 60) % 60, 10);
          if (that.time.m < 10) {
            that.$set(that.time, "m", "0" + that.time.m);
            // that.$set(that.time.m);
          }
          that.time.s = parseInt((date / 1000) % 60, 10);
          if (that.time.s < 10) {
            that.$set(that.time, "s", "0" + that.time.s);
            // that.$set(that.time.s);
          }
        }
      }, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  margin-top: 60px !important;
}
.none {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  .none_tip {
    font-size: 20px;
    color: #9a9a9a;
    text-align: center;
    margin-bottom: 40px;
  }
  .goStudy {
    width: 180px;
    height: 60px;
    background: #029aff;
    border-radius: 10px;
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    text-align: center;
    line-height: 60px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.bannerImg {
  width: 100%;
  height: 400px;
  vertical-align: top;
}
.content_box {
  width: 100%;
  // height: 100%;
  background-color: #f2f2f2;
  overflow: hidden;
  .live_box {
    width: 1200px;
    background-color: #fff;
    margin: 20px auto;
    padding: 60px 40px;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-between;
    .classImg {
      width: 560px;
      height: 340px;
      margin-right: 40px;
    }
    .live_right {
      .live_tit {
        font-size: 24px;
        color: #343434;
        margin-bottom: 12px;
      }
      .live_info {
        font-size: 16px;
        color: #444444;
        line-height: 2;
      }
      .live_desc {
        font-size: 14px;
        color: #666;
        text-indent: 2em;
        line-height: 1.8;
      }
      .count_dowm {
        font-size: 14px;
        color: #9a9a9a;
        margin: 15px;
      }
      .start_btn {
        width: 194px;
        height: 44px;
        background: #029aff;
        border-radius: 22px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
      }
    }
  }
}
</style>
